import * as Blockly from 'blockly/core'
// import { LuaGenerator, Order } from 'blockly/lua'
import { BlockDefinition } from './common'

// TODO: When procedures are implemented, add the category to toolbox.json:
// {
//   "kind": "category",
//   "name": "%{BKY_C_PROCEDURES}",
//   "categoryStyle": "procedures",
//   "custom": "PROCEDURES"
// }

export const PROCEDURE_CATEGORY = 'PROCEDURES'
export const MAKE_PROCEDURE_BUTTON_KEY = 'MAKE_PROCEDURE'

export const procedureDefaults: Partial<BlockDefinition> = {
  style: 'procedures',
}

export const procedureBlocks: Array<BlockDefinition> = []

export const generateProcedurePreamble = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _workspace: Blockly.Workspace,
) => {
  // TODO: Implement this in a future phase.
  return ''
}

const makeProcedureButtonCallback = (/* button: Blockly.FlyoutButton */) => {
  // TODO: Implement this in a future phase.
}

const proceduresFlyoutCallback = (/* workspace: Blockly.Workspace */) => {
  // TODO: Implement this in a future phase.
  const blockList: Blockly.utils.toolbox.FlyoutDefinition = [
    {
      kind: 'button',
      text: '%{BKY_B_MAKE_NEW_PROCEDURE}',
      callbackkey: MAKE_PROCEDURE_BUTTON_KEY,
    },
  ]

  return blockList
}

export const registerProcedureCallbacks = (workspace: Blockly.WorkspaceSvg) => {
  workspace.registerToolboxCategoryCallback(
    PROCEDURE_CATEGORY,
    proceduresFlyoutCallback,
  )
  workspace.registerButtonCallback(
    MAKE_PROCEDURE_BUTTON_KEY,
    makeProcedureButtonCallback,
  )
}
